import PrivacyPage from "@landingClient/pages/landing/Privacy";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(landing)/privacy")({
  component: PrivacyPage,
});
